import moment from 'moment-ja'
export default {
  /*
    数値のカンマ区切り・小数点指定・0埋め・分割を行う
    n: Number
    decimal: 小数点桁数(0埋めもされる)
    commaFlag: カンマ区切りを行うかどうか
    dividend: 10の何乗で割るか(百万円表示etcのため)
  */
  nFormat (n, decimal, commaFlag, devidend) {
    if (n === undefined || n === null || n === '') {
      return ''
    }
    n = n / Math.pow(10, devidend)
    n = Math.round(n * Math.pow(10, decimal)) / Math.pow(10, decimal)
    n = n.toFixed(decimal)
    n = commaFlag ? n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : n
    return n
  },
  /*
    日付文字列のフォーマットを行う
    s: String
    format: フォーマット
  */
  dFormat (s, format) {
    return moment(s).format(format)
  },
  /*
    日付文字列からYYYY-MM-DD hh:mmフォーマットを行う
    s: String
  */
  ymdhmFormat (s) {
    return moment(s).format('YYYY-MM-DD HH:mm')
  },
  /*
    日付文字列からYYYY-MM-DDフォーマットを行う
    s: String
  */
  ymdFormat (s) {
    return moment(s).format('YYYY-MM-DD')
  },
  /*
    日付文字列からYYYY-MM-DD hh:mmフォーマット(UTC)を行う
    s: String
  */
  ymdhmFormatUTC (s) {
    return moment.utc(s).format('YYYY-MM-DD HH:mm')
  },
  /*
    日付文字列からYYYY-MM-DDフォーマット(UTC)を行う
    s: String
  */
  ymdFormatUTC (s) {
    return moment.utc(s).format('YYYY-MM-DD')
  }
}
